import Modal from "common/components/Modal/Modal"
import NewRemesaForm, {
  NewRemesaFormData,
} from "features/Tesoreria/components/NewRemesaForm"
import { useTranslation } from "react-i18next"

const NewRemesaFormModal = ({
  showNewRemesa,
  handleOpenNewRemesa,
  handleCreateRemesa,
}: {
  showNewRemesa: {
    data: NewRemesaFormData | null
    status: boolean
  }
  handleOpenNewRemesa: (isOpen: boolean) => void
  handleCreateRemesa?: (values: $TSMigrationFixMe) => void
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      header={t("cartera.modal.headerRemittance")}
      visible={showNewRemesa.status}
      onHide={() => handleOpenNewRemesa(false)}
      size='small'
      maskClassName='!tw-z-20'
    >
      {showNewRemesa?.data && (
        <NewRemesaForm
          hideModal={() => handleOpenNewRemesa(false)}
          onHide={() => handleOpenNewRemesa(false)}
          handleCreate={handleCreateRemesa}
          data={showNewRemesa.data}
          t={t}
        />
      )}
    </Modal>
  )
}

export default NewRemesaFormModal
